'use client';

import { useEffect } from 'react';

import { useConsent } from '@/lib/contexts/consent/ConsentProvider';

import { setLoggerConsent } from '../consent';

/**
 * Bridges the app consent system into the logger enhancer pipeline.
 * When enhanced-logging consent is denied, user/tenant data is stripped
 * from every LogEntry before it reaches any plugin.
 * Mount once at the top of the tree (already done in LoggingBootstrap).
 */
export function useLoggerConsentSync() {
  const { hasConsent, consentVersion } = useConsent();

  useEffect(() => {
    setLoggerConsent(hasConsent('logging'));
  }, [hasConsent, consentVersion]);
}
